import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Root } from './native-state.dev';

let store={ 
    searchDone:false
};
// TEMPORARIAMENTE — apenas para teste:
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <>
    <Root initial={store} /> 
    <App />
  </>
);

